const MAP = {
  light: {
    box: 'inline-flex items-center gap-2',
    btn: 'w-9 h-8 rounded-lg cursor-pointer text-sm text-[#4a463c]',
    btnStyle: { border: '1px solid #d8d0bf', background: '#fff' },
    counter: 'text-[11.5px] text-[#8a8375]',
    counterText: (n, t) => `Frame ${n} / ${t}`,
  },
  dark: {
    box: 'inline-flex items-center gap-[6px]',
    btn: 'w-[34px] h-[30px] rounded-[7px] cursor-pointer text-[13px]',
    btnStyle: { border: '1px solid rgba(255,255,255,0.22)', background: 'rgba(255,255,255,0.07)', color: '#e7e3d8' },
    counter: 'text-[10px] opacity-50',
    counterText: (n, t) => `Frame ${n} / ${t}`,
  },
  industry: {
    box: 'inline-flex items-center gap-[6px]',
    btn: 'btn btn-secondary',
    btnStyle: { width: 38, height: 32, padding: 0 },
    counter: 'text-[10.5px] tracking-[1px] text-neutral-600',
    counterText: (n, t) => `FRAME ${n} / ${t}`,
  },
}

export default function FrameNav({
  theme = 'light',
  prev,
  next,
  frameNo,
  total,
  className = '',
  showCounter = true,
  buttonClassName = '',
  buttonStyle,
  counterClassName = '',
}) {
  const m = MAP[theme] || MAP.light
  const btnCls = buttonClassName || m.btn
  const btnStyle = buttonStyle ?? m.btnStyle
  return (
    <div className={`${m.box} ${className}`}>
      <button onClick={prev} className={btnCls} style={btnStyle}>
        ←
      </button>
      <button onClick={next} className={btnCls} style={btnStyle}>
        →
      </button>
      {showCounter && (
        <span className={`${m.counter} ${counterClassName}`}>{m.counterText(frameNo, total)}</span>
      )}
    </div>
  )
}
